<template>
  <div class="auth-layout-wrap flex justify-center min-h-screen flex-col bg-cover items-center">
        <div class="container-session-v1 max-w-2xl">
            <BaseCard noPadding class="overflow-hidden">
              <div class="grid grid-cols-12">
                  <div class="col-span-12 lg:col-span-12 justify-center items-center">
                      <div class="p-5">
                        <img class="w-40 h-40 m-auto" src="/images/logo.png" alt="" />
                          <form @submit.prevent="handleLogin">
                              <div class="mb-3">
                                  <label class="text-xs text-gray-600" for="">E-mail</label>
                                  <input 
                                  class="w-full px-4 py-1 bg-gray-100 focus:outline-none border border-gray-400 rounded-full" 
                                  v-model="email" 
                                  type="email" 
                                  placeholder="">
                              </div>
                              <div class="mb-3">
                                  <label class="text-xs text-gray-600" for="">Senha</label>
                                  <input class="w-full px-4 py-1 bg-gray-100 focus:outline-none border border-gray-400 rounded-full" 
                                  v-model="password"
                                  value="askjhdgahsgd" 
                                  type="password" 
                                  placeholder="">
                              </div>
                              <div class="mb-4">
                                  <BaseBtn type="submit" block class="bg-purple-500 mb-2 text-white  rounded-full">Entrar</BaseBtn>
                              </div>
                              <div class="text-center">
                                <a class="hover:text-purple-500 underline text-gray-600" href="#">Esqueceu a senha?</a>
                              </div>
                          </form>
                      </div>
                  </div>
                  
              </div>
            </BaseCard>
            
        </div>
    </div>
</template>

<script>

import { useStore } from 'vuex';
import authService from '../../shared/api/services/authService';

export default {
  data() {
    return {
      email: '',
      senha: '',
    };
  },
  methods: {
    async handleLogin() {
      const store = useStore();
      //const response = authService.login(this.email, this.password)
/*
      try {
            const response = api.post('/login', { 'email': email , 'password': password });
            return response.data;
        } catch (error) {
            console.error('Erro ao realizar login:', error);
            throw error;
        }
        */

    
      try {
        await this.$store.dispatch('login', { email: this.email, password: this.password });
        this.$router.push('/dashboard'); // Redireciona para a página protegida
      } catch (error) {
        console.log(error);
        alert('Erro ao tentar fazer login!');
      }
      
    },
  },
};
</script>
